import { render } from "./SelectNewTrayekMutationForm.vue?vue&type=template&id=774c442d&ts=true"
import script from "./SelectNewTrayekMutationForm.vue?vue&type=script&lang=ts"
export * from "./SelectNewTrayekMutationForm.vue?vue&type=script&lang=ts"

import "./SelectNewTrayekMutationForm.vue?vue&type=style&index=0&id=774c442d&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__